import { Breakpoint } from "../Breakpoint";

export function transformBreakpointToEmNumber(breakpoint: Breakpoint): number {
    if (breakpoint === Breakpoint.sm) {
        return 40;
    }
    if (breakpoint === Breakpoint.md) {
        return 60;
    }
    if (breakpoint === Breakpoint.lg) {
        return 75;
    }
    if (breakpoint === Breakpoint.xl) {
        return 110;
    }

    return 0; // breakpoint == Breakpoint.xs
}
